import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetCampaigns } from '../../../service/hooks';
import { cn } from '../../../utils/helpers';
import useAuthStore from '../../../store/useAuthStore';
import { Button } from '../../common';

const Header: FC = () => {
  const navigate = useNavigate();
  const { data } = useGetCampaigns({ page: 1, size: 0, sort: '', name: '' });
  const { profile } = useAuthStore();

  const handleClickAdd = () => {
    navigate('/campaign/new');
  };

  return (
    <div className={cn('bg-light-gray', 'flex items-center justify-between')}>
      <div className="px-8 flex items-center gap-4">
        <img src={profile?.picture} alt="" className={cn('h-[50px] w-[50px]', 'rounded-full')} />
        <div className="pr-4 border-r-2 border-gray h-[50px] flex items-center">
          <p className="font-semibold">
            {profile?.given_name} {profile?.family_name}
          </p>
        </div>
        <button className={cn('text-content', 'flex items-center gap-2')} onClick={() => navigate('/logout')}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
            <path
              d="M0 10C0 10.2652 0.105357 10.5196 0.292893 10.7071C0.48043 10.8946 0.734784 11 1 11H8.59L6.29 13.29C6.19627 13.383 6.12188 13.4936 6.07111 13.6154C6.02034 13.7373 5.9942 13.868 5.9942 14C5.9942 14.132 6.02034 14.2627 6.07111 14.3846C6.12188 14.5064 6.19627 14.617 6.29 14.71C6.38296 14.8037 6.49356 14.8781 6.61542 14.9289C6.73728 14.9797 6.86799 15.0058 7 15.0058C7.13201 15.0058 7.26272 14.9797 7.38458 14.9289C7.50644 14.8781 7.61704 14.8037 7.71 14.71L11.71 10.71C11.801 10.6149 11.8724 10.5028 11.92 10.38C12.02 10.1365 12.02 9.86346 11.92 9.62C11.8724 9.49725 11.801 9.3851 11.71 9.29L7.71 5.29C7.61676 5.19676 7.50607 5.1228 7.38425 5.07234C7.26243 5.02188 7.13186 4.99591 7 4.99591C6.86814 4.99591 6.73757 5.02188 6.61575 5.07234C6.49393 5.1228 6.38324 5.19676 6.29 5.29C6.19676 5.38324 6.1228 5.49393 6.07234 5.61575C6.02188 5.73757 5.99591 5.86814 5.99591 6C5.99591 6.13186 6.02188 6.26243 6.07234 6.38425C6.1228 6.50607 6.19676 6.61676 6.29 6.71L8.59 9H1C0.734784 9 0.48043 9.10536 0.292893 9.29289C0.105357 9.48043 0 9.73478 0 10ZM13 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V6C0 6.26522 0.105357 6.51957 0.292893 6.70711C0.48043 6.89464 0.734784 7 1 7C1.26522 7 1.51957 6.89464 1.70711 6.70711C1.89464 6.51957 2 6.26522 2 6V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H13C13.2652 2 13.5196 2.10536 13.7071 2.29289C13.8946 2.48043 14 2.73478 14 3V17C14 17.2652 13.8946 17.5196 13.7071 17.7071C13.5196 17.8946 13.2652 18 13 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V14C2 13.7348 1.89464 13.4804 1.70711 13.2929C1.51957 13.1054 1.26522 13 1 13C0.734784 13 0.48043 13.1054 0.292893 13.2929C0.105357 13.4804 0 13.7348 0 14V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H13C13.7956 20 14.5587 19.6839 15.1213 19.1213C15.6839 18.5587 16 17.7956 16 17V3C16 2.20435 15.6839 1.44129 15.1213 0.87868C14.5587 0.316071 13.7956 0 13 0Z"
              fill="#6E6E6E"
            />
          </svg>
          Signout
        </button>
      </div>
      <div className="flex gap-8">
        <Button onClick={handleClickAdd}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M10 0C4.47656 0 0 4.47656 0 10C0 15.5234 4.47656 20 10 20C15.5234 20 20 15.5234 20 10C20 4.47656 15.5234 0 10 0ZM15.832 10.832C15.832 11.293 15.4609 11.6641 15 11.6641H11.668V15C11.668 15.4609 11.2969 15.832 10.8359 15.832H9.16797C8.70703 15.832 8.33594 15.457 8.33594 15V11.668H5C4.53906 11.668 4.16797 11.293 4.16797 10.8359V9.16797C4.16797 8.70703 4.53906 8.33594 5 8.33594H8.33203V5C8.33203 4.53906 8.70312 4.16797 9.16406 4.16797H10.832C11.293 4.16797 11.6641 4.54297 11.6641 5V8.33203H15C15.4609 8.33203 15.832 8.70703 15.832 9.16406V10.832Z"
              fill="#E8EAF0"
            />
          </svg>
          Add Campaign
        </Button>
        <div
          className={cn(
            'pl-10 pr-16 py-4',
            'flex items-center gap-4',
            'bg-raisin-black h-full',
            'border-l-4 border-[#5E6D96]',
          )}
        >
          <div className={cn('rounded-full p-4 bg-positive', 'w-[50px] h-[50px]', 'flex items-center justify-center')}>
            <p className="text-2xl">{data?.totalElements}</p>
          </div>
          <p className="text-light-gray">
            Total <br /> Campaigns
          </p>
        </div>
      </div>
    </div>
  );
};

export default Header;
